import React from 'react';
import { Page } from 'components';
import { ShipmentTypesProvider } from './ShipmentTypesContext';
import ShipmentTypes from './ShipmentTypes';


let Index = () => {
    return (
        <ShipmentTypesProvider>
            <Page title="Shipment Types">
                <ShipmentTypes />
            </Page>
        </ShipmentTypesProvider>
    );
}

export default Index;